'use strict';

var App = require('app');
var i18n = require('utils/i18n');
var Notification = require('utils/notification');
var Utils = require('components/common/utils');

const active = 'active';

var FunctionBlockParametrizationView = Backbone.Marionette.ItemView.extend({
    template: require('components/devices/templates/controller/function_blocks'),

    events: {
        'click a.js-fb-tab': function (e) {
            this.activeTab = $(e.currentTarget).data('tab');
            this.update();
        },
        'click a.js-fb-block': function (e) {
            e.preventDefault();
            e.stopPropagation();
            this.switchBlock(
                this.activeTab == 'active' ? $(e.currentTarget).data('group') : this.activeTab,
                $(e.currentTarget).data('block'),
                !$(e.currentTarget).data('value')
            );
        },
    },

    initialize: function (options) {
        this.device = options.device;
        this.activeTab = options.activeTab || active;
        this.readMode = options.readOnly;
        this.data = {};
        this.loading = false;
    },

    onShow: function () {
        this.update();
    },

    serializeData: function () {
        var self = this;
        var tabList = [
            {
                tabID: 'active',
                tabHeading: i18n.TR('Aktiviert'),
                active: this.activeTab === active,
                readOnly: this.readMode,
            },
        ];

        if (this.data.groups) {
            this.data.groups.forEach(function (grp) {
                tabList.push({
                    tabID: grp,
                    tabHeading: i18n.TR(grp),
                    active: self.activeTab === grp,
                    readOnly: self.readMode,
                });
            });
        }

        return {
            readMode: this.readMode,
            tabs: tabList,
            blocks: this.data.blocks,
            error: this.data.error,
            loading: this.loading,
        };
    },

    switchBlock: function (group, block, value) {
        var self = this;
        var hint = value
            ? i18n.TR('Wollen Sie den Funktionsblock {{block}} aktivieren?')
            : i18n.TR('Wollen Sie den Funktionsblock {{block}} deaktivieren?');
        hint = hint.replace('{{block}}', group + '/' + block);
        var actionLabel = value ? i18n.TR('Aktivieren') : i18n.TR('Deaktivieren');

        Utils.showConfirmationDialog({
            title: i18n.TR('Funktionsblock schalten'),
            hint: hint,
            action_label: actionLabel,

            action_cb: function () {
                $.when(App.request('device:fcb:change', self.device.id, group, block, value)).done(function (r) {
                    if (r) {
                        self.data = {};
                        Backbone.history.loadUrl(Backbone.history.fragment);
                    } else {
                        Notification.show(
                            'error',
                            i18n.TR('Fehler'),
                            i18n.TR('Die Umschaltung des Funktionsblocks ist fehlgeschlagen.')
                        );
                    }
                });
            },
        });
    },

    update: function () {
        var self = this;

        this.loading = true;
        this.data.error = undefined;
        self.render();

        var reqGroups = !this.data.groups ? App.request('device:fcb:groups', this.device.id) : undefined;
        var reqBlocks = App.request('device:fcb:blocks', this.device.id, this.activeTab == active, this.activeTab);
        $.when(reqGroups, reqBlocks).done(function (groups, blocks) {
            if (reqGroups) {
                self.data.groups = groups;
                if (!groups) {
                    self.data.error = true;
                }
            }
            if (reqBlocks) {
                self.data.blocks = blocks;
                if (!blocks) {
                    self.data.error = true;
                }
            }
            this.loading = false;
            self.render();
        });
    },
});

module.exports = FunctionBlockParametrizationView;
